<template lang="pug">
WorkBreakPolicySelect(
  :value="workBreakPolicyId"
  :work-break-policy-options="options"
  allow-include-all
  :disabled="disabled"
  @input="updateWorkBreakPolicyId"
)
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import WorkBreakPolicySelect from '../work_break_policies/WorkBreakPolicySelect.vue';

export default {
  name: 'TimeEntriesWorkBreakPolicySelect',
  components: { WorkBreakPolicySelect },
  props: {
    workBreakPolicyId: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    workBreakPolicyOptions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['input'],
  computed: {
    ...mapState(['showCurrentOrganization']),
    ...mapGetters(['organizations', 'organizationId']),
    options() {
      return this.showCurrentOrganization || this.organizations.length === 1
        ? this.orgWorkBreakPolicies
        : this.groupedWorkBreakPolicies;
    },
    orgWorkBreakPolicies() {
      return this.workBreakPolicyOptions.filter((policy) => policy.organization_id === this.organizationId);
    },
    groupedWorkBreakPolicies() {
      return this.organizations.map((org) => {
        return {
          text: org.text,
          children: this.workBreakPolicyOptions.filter((policy) => policy.organization_id === +org.id),
        };
      });
    },
  },
  methods: {
    updateWorkBreakPolicyId(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>
